import styled from 'styled-components';

export const ShoppingCartContainer = styled.section<{ hasCrossSell: boolean }>`
  padding-bottom: ${({ hasCrossSell }) => (hasCrossSell ? '0rem' : '6.75rem')};
  background-color: ${({ theme }) => theme.colors.gray8};

  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  .hefesto-checkbox {
    gap: 1rem;
    .hefesto-checkbox__item-check {
      width: 1rem;
      height: 1rem;
    }
  }
`;

export const Container = styled.div`
  padding: 1.5rem;
`;

export const NoWrapChipContainer = styled.div<{ disabledChip?: boolean }>`
  display: flex;
  flex-direction: column;

  ${({ disabledChip }) =>
    disabledChip &&
    `
    .hefesto-chip .mdc-chip--selected, 
    .hefesto-chip .mdc-chip {
      cursor: default;
      pointer-events: none;
    }
    `};

  .hefesto-chip .mdc-chip--selected {
    cursor: default;
    pointer-events: none;
  }

  .mdc-chip-set {
    flex-wrap: nowrap;
  }
`;

export const ChipTitle = styled.span`
  font-size: 14px;
  line-height: 22px;
  color: #414e55;
`;

export const DateFieldTitle = styled.span`
  font-size: 14px;
  line-height: 22px;
  color: #414e55;
`;

export const DateFieldContainer = styled.div`
  display: flex;
  gap: 1.5rem;
  flex: 1;
  align-items: flex-end;

  button {
    height: 3rem;
    flex: 0.5;
  }

  & .hefesto-input-wrapper__label-wrapper__label {
    display: none;
  }

  & .hefesto-datefield__input input {
    width: 110px;
  }
`;

export const HelperText = styled.div`
  font-size: 12px;
  margin-top: 10px;
`;

export const PaginationContainer = styled.div<{ disableNextPage: boolean }>`
  padding: 0rem 1.5rem 1rem 1.5rem;
  ${({ disableNextPage }) =>
    disableNextPage &&
    `
    .hefesto-pagination__next {
    opacity: 0.36;
    pointer-events: none;
  }`}
`;

export const EShoppingCartContainer = styled.div`
  top: 0;
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(25, 45, 56, 0.5);
`;

export const Text = styled.span``;

export const TotalPriceTitle = styled.span`
  font-family: Work Sans;
  font-weight: 400;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 22px;
  letter-spacing: 0px;
  vertical-align: middle;
`;

export const TotalPriceText = styled.span`
  font-family: Work Sans;
  font-weight: 600;
  font-style: SemiBold;
  font-size: 16px;
  leading-trim: NONE;
  line-height: 24px;
  letter-spacing: 0px;
  vertical-align: middle;
`;

export const ChangeText = styled.span`
  font-family: Work Sans;
  font-weight: 400;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 22px;
  letter-spacing: 0px;
  vertical-align: middle;
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-offset: 0%;
  text-decoration-thickness: 0%;
  color: ${({ theme }) => theme.colors.blue6};
  cursor: pointer;
`;

export const SummaryItemsWrapper = styled.div``;

export const BottomItemsWrapper = styled.div`
  display: flex;
  gap: 12px;
  position: relative;
`;

export const BottomChangeTextWrapper = styled.div`
  display: flex;
  align-items: end;
`;

export const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  align-content: space-between;
  gap: 24px;
  flex-wrap: wrap;

  span.hefesto-title h2 {
    color: #495961;
  }

  .hefesto-keyvalueitem .hefesto-title h5 {
    color: #414e55;
    font-family: ${({ theme }) => theme.fonts.workSans};
  }
  & .hefesto-tag {
    height: 24px;
    color: #495961;
    align-self: center;
  }
  & .hefesto-keyvalueitem {
    width: 172px;
  }
  & .hefesto-title,
  .hefesto-keyvalueitem__value {
    display: flex;
    flex-wrap: nowrap;
    width: max-content;
  }
  .hefesto-simple-graph {
    gap: 4px;
    display: flex;
    flex-direction: column;

    .hefesto-simple-graph__value {
      line-height: 22px;
    }
  }
  .hefesto-simple-graph__bar-wrapper {
    min-width: 172px;
  }
  & h2 {
    margin: 0;
  }
  & > button {
    align-self: flex-end;
  }
`;

export const EShoppingCart = styled.div`
  position: fixed;
  width: 90%;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 0.5rem;
  max-width: 31.25rem;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  padding: 2rem 0.5rem;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 2rem;
  }
`;

export const WrapperText = styled.div<{ direction?: 'column' | 'row' }>`
  display: flex;
  flex-direction: ${({ direction }) => direction || 'column'};
  ${({ direction }) =>
    direction &&
    direction === 'row' &&
    `
    gap: 2rem;

    span.hefesto-icon {
      width: 1rem;
      align-items: center;
      display: flex;
      align-content: center;
      align-self: center;
    }
  }`}
`;

export const ErrorText = styled.span`
  color: ${({ theme }) => theme.colors.red};
  font-size: 14px;
`;

export const InformationPanelWrapper = styled.div`
  width: 100%;
  position: relative;

  .hefesto-information-panel {
    position: absolute;
    bottom: 0;
    margin-right: 50%;
    margin-left: 50%;

    > div > button {
      display: none;
    }
  }
`;

export const QtyContainer = styled.div<{ disabled?: boolean }>`
  ${({ disabled }) =>
    !disabled &&
    `
    :hover {
      input {
        border: 0.125rem solid #0069ac;
      }
      span {
        color: #0069ac;
      }
    }
  `}
`;
export const QtyLabel = styled.span`
  font-size: 14px;
  padding: 0px 1rem;
  color: #414e55;
`;
export const QtyInputContainer = styled.div`
  display: flex;
  position: relative;
`;
export const QtyInput = styled.input`
  width: 100%;
  outline: none;
  height: 3rem;
  border-radius: 0.25rem;
  border: 0.063rem solid #5d6569;
  padding: 0.75rem 0.75rem;
  padding-right: calc(1.5rem + 0.75rem);
  color: #414e55;
  font-size: 1rem;
  text-align: center;
`;
export const QtyInputButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0.05rem;
  height: calc(100% - 0.125rem);
`;
export const CartBpInfo = styled.div`
  display: flex;
  gap: 16px;
  padding: 0 1.5rem;
  flex-wrap: wrap;

  & > * {
    flex: 1;
    min-width: 240px;
  }
`;

export const QtyButton = styled.button`
  height: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  background: #83929b;
  color: #fff;
  outline: none;
  border: none;
  cursor: pointer;
  :hover:not(:disabled) {
    background-color: #0069ac;
  }
  :disabled {
    cursor: not-allowed;
    opacity: 0.4;
    pointer-events: none;
  }
`;
